import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "zidongbuhuobiangengjilu"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "自动补货变更记录")], -1);

const _hoisted_4 = {
  class: "panel-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
    data: $data.list,
    border: "",
    small: "",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "gname",
      label: "彩种类型",
      align: "center",
      width: "100"
    }), _createVNode(_component_el_table_column, {
      property: "write_time",
      label: "变更时间",
      align: "center",
      width: "180"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.write_time)), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "remark",
      label: "变更说明",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "old_value",
      label: "原值",
      align: "center",
      width: "80"
    }), _createVNode(_component_el_table_column, {
      property: "new_value",
      label: "新值",
      align: "center",
      width: "80"
    }), _createVNode(_component_el_table_column, {
      property: "operator",
      label: "变更人",
      align: "center",
      width: "120"
    }), _createVNode(_component_el_table_column, {
      property: "ip",
      label: "IP",
      align: "center",
      width: "150"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    small: "",
    class: "paging",
    onCurrentChange: $options.get_data,
    modelValue: $data.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.page = $event),
    "page-size": 20,
    "pager-count": 5,
    total: $data.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper",
    "prev-text": "上一页",
    "next-text": "下一页",
    "hide-on-single-page": ""
  }, null, 8, ["onCurrentChange", "modelValue", "total"])])])]);
}